import { Stack } from "@mui/material";
import AdronTypography from "../components/ui/AdronTypography";
import Box from "@mui/material/Box";
import IconComponent from "../components/ui/IconComponent";
import { ErrorDictionary } from "../errorDictionary";
import { ErrorCode } from "../class/Error";
import CustomPaper from "./CustomPaper";

interface Props {
  errorCode: ErrorCode;
}

const ErrorPaper = ({ errorCode }: Props) => {
  return (
    <CustomPaper
      sx={{
        border: `1px solid #EF4444`,
        width: "92% !important",
        marginBottom: "10px !important",
        backgroundColor: "transparent !important",
        position: "relative",
      }}
    >
      <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
        <Stack direction={"column"} spacing={1}>
          <AdronTypography fontWeight={600} value={ErrorDictionary[errorCode].message} />
          {ErrorDictionary[errorCode].description !== "" && (
            <AdronTypography value={ErrorDictionary[errorCode].description} />
          )}
        </Stack>
        <Box sx={{ paddingLeft: 1 }}>
          <IconComponent iconName={"ErrorTriangle"} type={"asBackground"} size={36} />
        </Box>
      </Stack>
    </CustomPaper>
  );
};

export default ErrorPaper;
